import {useEffect} from 'react';
import 'devextreme/data/odata/store';
import {EEProToolForm} from "../../../features/common/ee-pro";
import {useTitle} from "../../../contexts/title";
import {CountertopProvider} from "../../../features/common/ee-pro/contexts/countertopsContext";

export default function EEProPage() {
    const pageTitle = useTitle();
    useEffect(() => {
        pageTitle.setTitle('EE PRO')
    }, [])

    return (
        <CountertopProvider>
            <EEProToolForm></EEProToolForm>
        </CountertopProvider>
    )
}
